import React, {useEffect, useState} from "react";
import { Styles } from "./styles";
import {
  Autocomplete,
  Box, Checkbox,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import LeftBlue from "../../../Assets/Svg/OurServiceSvg/LeftBlue.svg";
import RightBlue from "../../../Assets/Svg/OurServiceSvg/RightBlue.svg";
import LeftOrange from "../../../Assets/Svg/OurServiceSvg/LeftOrange.svg";
import RightOrange from "../../../Assets/Svg/OurServiceSvg/RightOrange.svg";
import FormHelperText from "@mui/material/FormHelperText";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Files from "react-files";
import { Button } from "@mui/material";
import Slider from "@mui/material/Slider";

const PackageMainData = (props) => {
  const [errorText, setErrorText] = useState("");
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");

  const fonts = ["Mockads", "Escopedia", "Great Vibes"];
  const colors = ["#FFFFFF", "#303030", "#ECA601"];

  const {
    selectedCategories,
    handleCategoryChange,
    selectedSubcategoryDetails,
    handleSubcategoryChange,
    selectedSubcategory,
    Categories,
    selectedCategoryDetails,
    handleChange,
    formData,
    selectedGroups,
    setSelectedGroups,
    // New props for logo customization
    uploadOption = "logo",
    handleUploadOptionChange,
    handleFileChange,
    selectedFont = "Mockads",
    handleFontChange,
    selectedColor = "#EBF2FF",
    handleColorClick,
    fontSize = 44,
    handleFontSizeChange,
    logoName = "LOREM",
    handleLogoNameChange,
  } = props;

  const [groupOptions, setGroupOptions] = useState([]);
  const [calculatedPrice, setCalculatedPrice] = useState(0);
  const [basePrice, setBasePrice] = useState(0);

  useEffect(() => {
    const pricePerItem = selectedCategories === 48 ?
        formData.recipient_type === 'all_users' ? selectedCategoryDetails?.max_unit_price ?? 0 : selectedCategoryDetails?.min_unit_price ?? 0
        : selectedCategoryDetails?.unit_price ?? 0;

    const total = selectedGroups.reduce((sum, group) => {
      return sum + (group.count * pricePerItem);
    }, 0);
    setBasePrice(total * selectedSubcategoryDetails?.days / 30);

    let finalPrice = total;
    setCalculatedPrice(finalPrice);
  }, [selectedGroups, selectedCategoryDetails, selectedSubcategoryDetails, formData.recipient_type, selectedCategories]);

  const handleGroupSelection = (event, newValue) => {
    setSelectedGroups(newValue);
  };

  useEffect(() => {
    if (selectedCategoryDetails) {
      const allGroups =
          selectedCategoryDetails.groups ? selectedCategoryDetails.groups.map(group => ({
            ...group,
            serviceId: selectedCategoryDetails.id,
            serviceTitle: selectedCategoryDetails.name
          })) : []

      setGroupOptions(allGroups);
    }
    else{
      const allGroups = Categories.flatMap(category =>
          category.groups ? category.groups.map(group => ({
            ...group,
            serviceId: category.id,
            serviceTitle: category.name
          })) : []
      );
      setGroupOptions(allGroups);
    }
  }, [Categories,selectedCategoryDetails]);

  return (
      <Styles>
        <Box className="main-data-container">
          <Box className="form-data">
            <Grid
                container
                spacing={1}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
            >
              <Grid
                  item
                  xs={12}
                  sm={12}
                  md={11}
                  sx={{ paddingInlineStart: "0px !important",marginBottom:'15px' }}
              >
                <FormControl
                    fullWidth
                    variant="outlined"
                    sx={{
                      boxShadow: "1px 2px 4px #454040",
                      borderRadius: "8px",
                      background: "#F5F8FE",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "&:hover fieldset": {
                          borderColor: "#6B9DFE",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#007BFF",
                        },
                      },
                    }}
                >
                  <InputLabel
                      id="select-category-label"
                      sx={{
                        color: "#474747",
                        fontSize: "16px",
                        fontWeight: "500",
                        lineHeight: "20px",
                        "&.Mui-focused": {
                          color: "#007BFF",
                        },
                      }}
                  >
                    Service
                  </InputLabel>
                  <Select
                      labelId="select-category-label"
                      id="select-category"
                      value={selectedCategories}
                      onChange={(e) => {
                        handleCategoryChange(e?.target?.value);
                      }}
                      displayEmpty
                      label="Select Category"
                      sx={{
                        "& .MuiSelect-select": {
                          padding: "10px 12px",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiSelect-icon": {
                          color: "#707275",
                        },
                        "& .MuiMenu-paper": {
                          maxHeight: "200px",
                          backgroundColor: "#f5f8fe",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          borderRadius: "8px",
                          "& .MuiMenuItem-root": {
                            padding: "10px",
                            color: "#333",
                            fontSize: "14px",
                            borderBottom: "1px solid #9E9E9E",
                            '&[aria-selected="true"]': {
                              backgroundColor: "#007bff",
                              color: "#fff",
                            },
                            '&[data-focus="true"]': {
                              backgroundColor: "#007bff",
                            },
                          },
                        },
                        "&::-webkit-scrollbar": {
                          width: "8px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#F5F8FE",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#004571",
                          borderRadius: "4px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          background: "#004571",
                        },
                      }}
                      inputProps={{
                        "aria-label": "Select Category",
                      }}
                  >
                    {Categories.map((option) => (
                        <MenuItem
                            key={option.id}
                            value={option.id}
                            sx={{
                              padding: "10px",
                              color: "#333",
                              fontSize: "14px",
                              borderBottom: "1px solid #9E9E9E",
                            }}
                        >
                          {option.label}
                        </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {selectedCategoryDetails?.with_type &&
              <Grid
                  item
                  xs={12}
                  sm={12}
                  md={11}
                  sx={{ paddingInlineStart: "0px !important",marginBottom:'15px'  }}
              >
                <FormControl
                    fullWidth
                    variant="outlined"
                    sx={{
                      boxShadow: "1px 2px 4px #454040",
                      borderRadius: "8px",
                      background: "#F5F8FE",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "&:hover fieldset": {
                          borderColor: "#6B9DFE",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#007BFF",
                        },
                      },
                    }}
                >
                  <InputLabel
                      id="select-subcategory-label"
                      sx={{
                        color: "#474747",
                        fontSize: "16px",
                        fontWeight: "500",
                        lineHeight: "20px",
                        "&.Mui-focused": {
                          color: "#007BFF",
                        },
                      }}
                  >
                    Type
                  </InputLabel>
                  <Select
                      labelId="select-subcategory-label"
                      id="select-subcategory"
                      value={selectedSubcategory}
                      onChange={(e) => {
                        handleSubcategoryChange(e?.target?.value);
                      }}
                      displayEmpty
                      label="Select Subcategories"
                      sx={{
                        "& .MuiSelect-select": {
                          padding: "10px 12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent:'space-between',
                        },
                        "& .MuiSelect-icon": {
                          color: "#707275",
                        },
                        "& .MuiMenu-paper": {
                          maxHeight: "200px",
                          backgroundColor: "#f5f8fe",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          borderRadius: "8px",
                          "& .MuiMenuItem-root": {
                            padding: "10px",
                            color: "#333",
                            fontSize: "14px",
                            borderBottom: "1px solid #9E9E9E",
                            '&[aria-selected="true"]': {
                              backgroundColor: "#007bff",
                              color: "#fff",
                            },
                            '&[data-focus="true"]': {
                              backgroundColor: "#007bff",
                            },
                          },
                        },
                        "&::-webkit-scrollbar": {
                          width: "8px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#F5F8FE",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#004571",
                          borderRadius: "4px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          background: "#004571",
                        },
                      }}
                  >
                    {selectedCategoryDetails &&
                    selectedCategoryDetails.subCategories.map((option) => (
                        <MenuItem
                            key={option.id}
                            value={option.id}
                            sx={{
                              padding: "10px",
                              color: "#333",
                              fontSize: "14px",
                              borderBottom: "1px solid #9E9E9E",
                              justifyContent: "space-between",
                            }}
                        >
                          <Typography>{option.label}</Typography>
                          <Typography>{option.price}$</Typography>
                        </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              }

              <Grid
                  item
                  xs={12}
                  sm={12}
                  md={11}
                  sx={{ paddingInlineStart: "0px !important" }}
              >
                <TextField
                    fullWidth
                    rows={3}
                    multiline
                    minRows={1}
                    readOnly
                    variant="outlined"
                    InputLabelProps={{
                      style: {
                        color: "#434343",
                        fontSize: "13px",
                        padding: "5px",
                      },
                    }}
                    value={selectedCategoryDetails?.description}
                    onChange={null}
                    name="title"
                    placeholder="Type Title"
                    InputProps={{
                      readOnly: true,
                    }}
                    sx={{
                      background: "white",
                      borderRadius: "8px",
                      "& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input":
                          {
                            padding: "10px",
                          },
                      "& .MuiOutlinedInput-root": {
                        border: "1px solid #5F5F5F",
                        boxShadow: "-2px 2px 4px #00000040",
                        borderRadius: "8px",
                        "& fieldset": {
                          border: "none",
                        },
                      },
                    }}
                />
              </Grid>

              {selectedCategoryDetails?.with_groups && (
                  <Grid
                      item
                      xs={12}
                      sm={12}
                      md={11}
                      sx={{ paddingInlineStart: "0px !important" }}
                  >
                    <Box
                        sx={{
                          borderBottom: "2px solid #80808050",
                          paddingBlock: "10px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                    >
                      {
                        groupOptions.length > 0 &&
                        <Autocomplete
                            multiple
                            options={groupOptions}
                            getOptionLabel={(option) => `${option.name}  - ${option.count} items`}
                            value={selectedGroups}
                            onChange={handleGroupSelection}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Select Groups"
                                    placeholder="Choose groups to subscribe"
                                />
                            )}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox checked={selected} />
                                  {option.name} - {option.count} items
                                </li>
                            )}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            sx={{ width: '100%' }}
                        />
                      }

                      {selectedGroups.length > 0 && (
                          <Box mt={2}>
                            <Typography variant="body2">
                              Selected Groups: {selectedGroups.length}
                            </Typography>
                            <Typography variant="body2">
                              Total Items: {selectedGroups.reduce((sum, group) => sum + group.count, 0)}
                            </Typography>
                          </Box>
                      )}
                    </Box>
                  </Grid>
              )}

              {selectedCategoryDetails?.FiledTitle && (
                  <Grid
                      item
                      xs={12}
                      sm={12}
                      md={11}
                      sx={{ paddingInlineStart: "0px !important" }}
                  >
                    <TextField
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          style: {
                            color: "#434343",
                            fontSize: "13px",
                            padding: "5px",
                          },
                        }}
                        value={formData.title}
                        onChange={(e) => handleChange("title", e.target.value)}
                        name="title"
                        placeholder="Type Title"
                        sx={{
                          background: "white",
                          borderRadius: "8px",
                          "& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input":
                              {
                                padding: "10px",
                              },
                          "& .MuiOutlinedInput-root": {
                            border: "1px solid #5F5F5F",
                            boxShadow: "-2px 2px 4px #00000040",
                            borderRadius: "8px",
                            "& fieldset": {
                              border: "none",
                            },
                          },
                        }}
                    />
                  </Grid>
              )}

              {selectedCategoryDetails?.FiledDescription && (
                  <Grid
                      item
                      xs={12}
                      sm={12}
                      md={11}
                      sx={{ paddingInlineStart: "0px !important" }}
                  >
                    <TextField
                        fullWidth
                        variant="outlined"
                        multiline
                        minRows={1}
                        InputLabelProps={{
                          style: { color: "#434343", fontSize: "13px" },
                        }}
                        value={formData.description}
                        onChange={(e) => handleChange("description", e.target.value)}
                        name="description"
                        placeholder="Add your description here..."
                        sx={{
                          background: "white",
                          borderRadius: "8px",
                          "& .MuiOutlinedInput-root": {
                            border: "1px solid #5F5F5F",
                            boxShadow: "-2px 2px 4px #00000040",
                            borderRadius: "8px",
                            "& fieldset": {
                              border: "none",
                            },
                            "& textarea": {
                              borderRadius: "10px",
                            },
                          },
                        }}
                    />
                  </Grid>
              )}

              {selectedCategoryDetails?.FiledPanel &&(
                  <Grid
                      item
                      xs={12}
                      sm={12}
                      md={11}
                      sx={{ paddingInlineStart: "0px !important" }}
                  >
                    <TextField
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          style: {
                            color: "#434343",
                            fontSize: "13px",
                            padding: "5px",
                          },
                        }}
                        value={formData.panel_url}
                        onChange={(e) => {
                          const url = e.target.value;
                          handleChange("panel_url", url);
                        }}
                        name="panel_url"
                        placeholder="Put your Link here (e.g., https://example.com)"
                        sx={{
                          background: "white",
                          borderRadius: "8px",
                          "& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input": {
                            padding: "10px",
                          },
                          "& .MuiOutlinedInput-root": {
                            border: "1px solid #5F5F5F",
                            boxShadow: "-2px 2px 4px #00000040",
                            borderRadius: "8px",
                            "& fieldset": {
                              border: "none",
                            },
                          },
                        }}
                    />
                  </Grid>
              )}

              {/* Bulk Email Configuration - Same as individual service */}
              {selectedCategories === 48 && (
                  <Grid
                      item
                      xs={12}
                      sm={12}
                      md={11}
                      sx={{ paddingInlineStart: "0px !important" }}
                  >
                    <Typography variant="h6" sx={{ mb: 2 }}>Bulk Email Configuration</Typography>

                    {/* Recipient Type Selection */}
                    <FormControl component="fieldset" sx={{ mb: 3 }}>
                      <FormLabel component="legend">Choose Recipients</FormLabel>
                      <RadioGroup
                          value={formData.recipient_type || 'custom_emails'}
                          onChange={(e) => handleChange('recipient_type', e.target.value)}
                      >
                        <FormControlLabel
                            value="all_users"
                            control={<Radio />}
                            label="System Users"
                        />
                        <FormControlLabel
                            value="custom_emails"
                            control={<Radio />}
                            label="Custom Emails (comma separated)"
                        />
                        <FormControlLabel
                            value="excel_file"
                            control={<Radio />}
                            label="Upload Excel File"
                        />
                      </RadioGroup>
                    </FormControl>

                    {/* Custom Emails Textarea */}
                    {formData.recipient_type === 'custom_emails' && (
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            label="Email Addresses"
                            placeholder="Enter email addresses separated by commas"
                            value={formData.custom_emails || ''}
                            onChange={(e) => handleChange('custom_emails', e.target.value)}
                            sx={{ mb: 2 }}
                            helperText="Enter email addresses separated by commas (e.g., email1@example.com, email2@example.com)"
                        />
                    )}

                    {/* Excel File Upload */}
                    {formData.recipient_type === 'excel_file' && (
                        <Box sx={{ mb: 2 }}>
                          <input
                              type="file"
                              accept=".csv"
                              onChange={(e) => handleChange('excel_file', e.target.files[0])}
                          />
                          <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
                            Upload Excel file with email addresses in the first column (csv file)
                          </Typography>
                        </Box>
                    )}

                    {/* Email Subject */}
                    <TextField
                        fullWidth
                        label="Email Subject"
                        value={formData.subject || ''}
                        onChange={(e) => handleChange('subject', e.target.value)}
                        sx={{ mb: 2 }}
                        required
                    />

                    {/* Email Message */}
                    <TextField
                        fullWidth
                        multiline
                        rows={6}
                        label="Email Message"
                        value={formData.message || ''}
                        onChange={(e) => handleChange('message', e.target.value)}
                        sx={{ mb: 2 }}
                        required
                        helperText="You can use HTML for formatting"
                    />
                  </Grid>
              )}

              <Grid
                  item
                  xs={12}
                  sm={12}
                  md={11}
                  sx={{ paddingInlineStart: "0px !important" }}
              >
                {
                  selectedCategoryDetails?.id === 47 ?
                      <label htmlFor={'countTicket'}>Hours</label>   :
                      <label htmlFor={'countTicket'}>{selectedCategoryDetails?.with_type ? "Days" : "count Ticket"}</label>
                }

                <TextField
                    fullWidth
                    variant="outlined"
                    type={'number'}
                    InputLabelProps={{
                      style: {
                        color: "#434343",
                        fontSize: "13px",
                        padding: "5px",
                      },
                    }}
                    value={selectedCategoryDetails?.with_type ?selectedSubcategoryDetails?.days :formData?.countTicket}
                    onChange={(e) => handleChange("countTicket", e.target.value)}
                    name="countTicket"
                    placeholder=""
                    InputProps={{
                      readOnly: selectedCategoryDetails?.with_type ? true :false,
                    }}
                    sx={{
                      background: "white",
                      borderRadius: "8px",
                      "& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input": {
                        padding: "10px",
                      },
                      "& .MuiOutlinedInput-root": {
                        border: "1px solid #5F5F5F",
                        boxShadow: "-2px 2px 4px #00000040",
                        borderRadius: "8px",
                        "& fieldset": {
                          border: "none",
                        },
                      },
                    }}
                />
                <FormHelperText sx={{
                  mt: 1,
                  fontSize: '12px',
                  color: '#5F5F5F',
                  textAlign: 'right',
                }}>
                  {selectedCategoryDetails?.with_type
                      ? ""
                      : `Minimum: ${selectedCategoryDetails?.min_count}, Maximum: ${selectedCategoryDetails?.max_count}`
                  }
                </FormHelperText>
              </Grid>

              <Grid
                  item
                  xs={12}
                  sm={12}
                  md={11}
                  sx={{ paddingInlineStart: "0px !important" }}
              >
                <label htmlFor={'price'}>Price</label>
                <TextField
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      style: {
                        color: "#434343",
                        fontSize: "13px",
                        padding: "5px",
                      },
                    }}
                    value={
                      selectedCategoryDetails?.with_groups ?
                          basePrice :
                          (selectedCategoryDetails?.with_type ?
                              selectedSubcategoryDetails?.price :
                              parseFloat((selectedCategories === 48 ?
                                  formData.recipient_type === 'all_users' ? selectedCategoryDetails?.max_unit_price ?? 0 : selectedCategoryDetails?.min_unit_price ?? 0
                                  : selectedCategoryDetails?.unit_price ?? 0) * formData.countTicket).toFixed(2))
                    }
                    onChange={null}
                    name="price"
                    placeholder=""
                    InputProps={{
                      readOnly: true,
                    }}
                    sx={{
                      background: "white",
                      borderRadius: "8px",
                      "& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input": {
                        padding: "10px",
                      },
                      "& .MuiOutlinedInput-root": {
                        border: "1px solid #5F5F5F",
                        boxShadow: "-2px 2px 4px #00000040",
                        borderRadius: "8px",
                        "& fieldset": {
                          border: "none",
                        },
                      },
                    }}
                />
              </Grid>
            </Grid>
          </Box>

          {/* Logo section remains the same */}
          {selectedCategoryDetails?.FiledImage && (
              <Box sx={{ width: { xs: "100%", sm: "100%" } }}>
                <Typography
                    sx={{
                      marginBottom: "10px",
                      fontWeight: "600",
                      fontSize: "24px",
                      lineHeight: "30px",
                      color: "#474747",
                    }}
                >
                  Logo Image *
                </Typography>

                <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "20px 0",
                    }}
                >
                  <Button
                      variant="outlined"
                      onClick={() => handleUploadOptionChange(uploadOption === "logo" ? "customLogo" : "logo")}
                      sx={{
                        fontWeight: "600",
                        border: "1px solid #3F78E0",
                        textTransform: "capitalize",
                        textAlign: "center",
                        borderRadius: "10px",
                        padding: "3px 40px",
                        background: "#FFFFFF",
                        color: "#3F78E0",
                        boxShadow:
                            "0px 5px 5px #00000040, inset 4px 7px 5px #FFFFFF30",
                        "&:hover": {
                          background: "none",
                        },
                      }}
                  >
                    {uploadOption === "logo"
                        ? "Switch to Custom Logo"
                        : "Switch to Photo Upload"}
                  </Button>
                </Box>
                <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      position: "relative",
                      justifyContent: "space-between",
                      width: "100%",
                      gap: "20px",
                    }}
                >
                  {/* Logo upload and custom logo sections remain the same */}
                  <Box
                      sx={{
                        width: { xs: "100%", md: "45%" },
                        opacity: uploadOption === "customLogo" ? 0.5 : 1,
                        pointerEvents:
                            uploadOption === "customLogo" ? "none" : "auto",
                      }}
                  >
                    <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: { xs: "300px", md: "100%", lg: "300px" },
                          textAlign: "center",
                          backgroundColor: "#FFFFFF",
                          cursor:
                              uploadOption === "customLogo" ? "not-allowed" : "pointer",
                          position: "relative",
                          border: "#303030 solid 1px",
                          borderRadius: "15px",
                        }}
                    >
                      <Files
                          onChange={(fileList) => handleFileChange(fileList)}
                          onError={(error) =>
                              console.error("File upload error:", error)
                          }
                          accepts={["image/*"]}
                          clickable
                          multiple={false}
                          maxFileSize={10485760}
                          disabled={uploadOption === "customLogo"}
                          style={{
                            opacity: 0,
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            top: 0,
                            left: 0,
                          }}
                      />
                      {formData.logo ? (
                          <Box
                              sx={{
                                position: "relative",
                                width: "80%",
                                height: "80%",
                                borderRadius: "10px",
                                overflow: "hidden",
                              }}
                          >
                            <img
                                src={URL.createObjectURL(formData.logo)}
                                alt="Uploaded Logo"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                  borderRadius: "10px",
                                }}
                            />
                            <IconButton
                                onClick={() => {
                                  handleChange("logo", null);
                                }}
                                sx={{
                                  position: "absolute",
                                  top: "5px",
                                  right: "5px",
                                  color: "white",
                                  backgroundColor: "red",
                                  borderRadius: "10px",
                                  "&:hover": {
                                    backgroundColor: "red",
                                  },
                                }}
                            >
                              <CloseIcon />
                            </IconButton>
                          </Box>
                      ) : (
                          <Typography variant="body2" color="textSecondary">
                            Click to upload a logo
                          </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box
                      sx={{
                        width: { xs: "100%", md: "50%" },
                        opacity: uploadOption === "logo" ? 0.5 : 1,
                        pointerEvents: uploadOption === "logo" ? "none" : "auto",
                        background: "#FFFFFF",
                        paddingBottom: "25px",
                        border: "1px solid #303030",
                        borderRadius: "10px",
                      }}
                  >
                    <Box
                        sx={{
                          display: "flex",
                          flexDirection: {
                            xs: "column",
                            sm: "row",
                            md: "column",
                            lg: "row",
                          },
                          justifyContent: {
                            xs: "space-between",
                            sm: "space-around",
                            md: "space-between",
                          },
                          alignItems: "center",
                          height: "100%",
                          padding: {
                            xs: "20px 20px",
                            sm: "0 20px",
                            md: "20px 20px",
                            lg: "0 20px",
                          },
                        }}
                    >
                      <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            width: "90%",
                          }}
                      >
                        <Box>
                          <Typography
                              sx={{
                                color: "#474747",
                                fontSize: "20px",
                                fontWeight: "600",
                                lineHeight: "30px",
                              }}
                          >
                            Pick a Custom Font
                          </Typography>
                          <TextField
                              fullWidth
                              variant="outlined"
                              value={logoName}
                              onChange={(e) => handleLogoNameChange(e.target.value)}
                              placeholder="Type Your Logo Name here"
                              size="small"
                              InputLabelProps={{
                                style: {
                                  fontSize: "16px",
                                  color: "#5F5F5F",
                                  lineHeight: "24px",
                                  fontWeight: "600",
                                  letterSpacing: "1px",
                                },
                              }}
                              sx={{
                                width: "95%",
                                boxShadow: "-2px 2px 4px #00000040",
                                borderRadius: "10px",
                                backgroundColor: "white",
                                marginTop: "10px",
                              }}
                          />
                        </Box>

                        <Box>
                          <Typography>Choose a Font</Typography>
                          <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "10px",
                                marginTop: "4px",
                                justifyContent: "space-evenly",
                              }}
                          >
                            {fonts.map((font) => (
                                <Box
                                    key={font}
                                    sx={{
                                      background: "#E5EDFF",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      flexDirection: "column",
                                      gap: "4px",
                                      border: "1px solid #959595",
                                      borderRadius: "10px",
                                      padding: {
                                        xs: "4px 6px",
                                        sm: "4px 12px",
                                        md: "4px 25px",
                                      },
                                    }}
                                >
                                  <Typography
                                      sx={{
                                        fontFamily: font,
                                        fontSize: "20px",
                                        lineHeight: "24px",
                                        fontWeight: "600",
                                        color: "#474747",
                                      }}
                                  >
                                    lorem
                                  </Typography>
                                  <Radio
                                      checked={selectedFont === font}
                                      onChange={() => handleFontChange(font)}
                                      sx={{
                                        color: "primary.main",
                                      }}
                                  />
                                </Box>
                            ))}
                          </Box>
                        </Box>
                        <Typography>Choose a color and font size</Typography>
                        <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "10px",
                            }}
                        >
                          <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "6px",
                              }}
                          >
                            <Box sx={{ display: "flex", gap: 2 }}>
                              {colors.map((color) => (
                                  <Box
                                      key={color}
                                      onClick={() => handleColorClick(color)}
                                      sx={{
                                        width: 20,
                                        height: 20,
                                        borderRadius: "50%",
                                        backgroundColor: color,
                                        cursor: "pointer",
                                        border: "1px #303030 solid",
                                        transition: "border 0.3s ease",
                                      }}
                                  />
                              ))}
                            </Box>
                          </Box>
                          <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "6px",
                              }}
                          >
                            <Slider
                                value={fontSize}
                                onChange={(e, newValue) => handleFontSizeChange(newValue)}
                                min={20}
                                max={50}
                                step={1}
                                valueLabelDisplay="auto"
                                sx={{ width: "100px" }}
                            />
                          </Box>
                        </Box>
                      </Box>
                      <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "6px",
                            height: "200px",
                          }}
                      >
                        <Typography
                            sx={{
                              fontSize: "18px",
                              lineHeight: "28px",
                              color: "#474747",
                            }}
                        >
                          Your Logo demo
                        </Typography>
                        <Box
                            sx={{
                              background: "radial-gradient(circle, #51AAFD, #002D68)",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              position: "relative",
                              padding: "40px",
                              borderRadius: "15px",
                              width: "100px",
                              height: "80px",
                              overflow: "hidden",
                            }}
                        >
                          <Typography
                              sx={{
                                fontSize: `${fontSize}px`,
                                fontWeight: "700",
                                color: selectedColor,
                                fontFamily: selectedFont,
                              }}
                          >
                            {logoName || "LOREM"}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
          )}
        </Box>
      </Styles>
  );
};

export default PackageMainData;